export function dedupArray<T>(array: T[]): T[] {
  return [...new Set(array)];
}

export function getRandomElementFromArray<T>(array: T[], maxIndex?: number): T {
  const length = maxIndex === undefined ? array.length : maxIndex + 1;
  return array[Math.floor(Math.random() * length)];
}
